import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { MarkupAction } from '../markup.action';

type IDependencies = IClientApiDependencySegment;

export const bulkUpdateMarkupEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(MarkupAction.bulkUpdate.started),
  switchMap((params) => {
    return dependencies.api.bulkUpdateMarkups(params).pipe(
      mergeMap(() => [MarkupAction.bulkUpdate.done({ params })]),
      catchApiError((error) => [
        MarkupAction.bulkUpdate.failed({ params, error }),
        createApiErrorNotification(error),
      ]),
    );
  }),
);
